<div
  class="flex items-center justify-center overflow-hidden rounded-full bg-brand-primary-lighter"
  [ngClass]="{
    'rounded-full': variant() === 'circle',
    'rounded-md': variant() === 'square',
    'h-8 w-8': size() === 'sm',
    'h-10 w-10': size() === 'md',
    'h-12 w-12': size() === 'lg',
    'h-24 w-24': size() === 'xl',
    'h-32 w-32': size() === '2xl'
  }"
>
  @if (image() || initials()) {
    @if (image(); as img) {
      <img
        [src]="img ?? ''"
        [alt]="alt() ?? ''"
        class="size-full"
        loading="lazy"
        (error)="onError()"
      />
    } @else if (initials()) {
      <span
        class="font-semibold leading-none text-brand-primary-pure"
        [ngClass]="{
          'text-sm': size() === 'sm',
          'text-md': size() === 'md',
          'text-lg': size() === 'lg',
          'text-2xl': size() === 'xl',
          'text-6xl': size() === '2xl'
        }"
        >{{ initials() }}</span
      >
    }
  } @else {
    <svg
      class="size-full text-brand-primary-pure"
      fill="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z"
      />
    </svg>
  }
</div>
